export class coursePaymentDetails {
    constructor(courseId) {
        this.courseId = courseId;
        this.data = {};

        this.inputFields = $('#kurs-payment-details input[type="text"]');
        this.saveBtn = $(".save-course-payment-details");
        this.priceField = $("#price");
        this.endDateField = $("#end-date");
        this.aboDauerField = $("#end-tage");
        this.errorClass = 'form-control-danger';
        this.addListeners();
    }

    addListeners(){
        const handler = this;
        this.saveBtn.on("click", function(){
            handler.saveCoursePaymentDetails(handler.courseId);
        });
        // remove "is-invalid"
        this.inputFields.on("input", function(){
            $(this).removeClass(handler.errorClass);
        });
        // change what you see
        $("input[type='radio'].change-abo-type").on("change", function(e){
            const id = $(this).val();
            $(".p-detail").addClass("hide");
            $('#' + id).removeClass("hide");
        });

    }

    saveCoursePaymentDetails(courseId){
        const data = {};
        const buyable = $("#buy_sell_switch").is(":checked");
        data.buyable = (buyable) ? 1 : 0;
        const price = this.priceField.val();
        data.price = (price !== undefined && price !== '') ? parseFloat(price.replace(/,/g, '.').replace('€', '')) : 0;
        const aboTyp = $("input[type='radio'].change-abo-type:checked").val();
        data.aboTyp = (aboTyp === 'sel-end-date') ? 1 : 2;
        data.endDate = this.endDateField.val();
        data.aboDauer = this.aboDauerField.val();

        const check = this.validateData(data);
        if (check){
            this.sendCoursePaymentDetails(courseId, data);
        }
    }

    validateData(data){
        $(".toast").remove();
        let status = true;
        // 1. check price
        if ( data.price == '' || data.price < 5){
            status = false;
            errorToast('Der Preis muss mindestens 5€ betragen', 'Fehler mit dem Preis', 12500, true);
            this.priceField.addClass(this.errorClass);
        }
        // 2. Datum
        if (data.aboTyp == 1){
            const datum = data.endDate;
            if (datum == undefined || datum == ''){
                status = false;
                errorToast('Bitte wähle ein neues Datum aus', 'Fehler mit dem Datum', 12500, true);
                this.endDateField.addClass(this.errorClass);
            }
        } else if (data.aboTyp == 2){
            const tage = data.aboDauer;
            if (tage <= 0){
                status = false;
                errorToast('Bitte ändere die Länge eines Abos, diese muss positiv sein!', 'Fehler mit der Abolänge', 15000, true);
                this.aboDauerField.addClass(this.errorClass);
            }
        }
        return status;
    }

    sendCoursePaymentDetails(courseId, data){
        data.action = 'save_course_payment_details';
        data.courseId = courseId;
        const config = {
            data: data,
            success: function(data){
                if (data.success){
                    successToast('Eingaben wurden gespeichert', 'Erfolgreich!', 6500, true);
                } else {
                    const msg = (data.error !== undefined) ? data.error : 'Eingaben konnten nicht gespeichert werden';
                    errorToast(msg, 'Fehler beim Speichern!', 10000, true);
                }
            }
        }
        ajaxSpinner(config, this.saveBtn);
    }

}